module.exports = __webpack_public_path__ + "static/media/NoPapers-explore.aee0e050.png";